const remoteFile = 'remoteEntry.js'
const config = {
  container: {
    type: 'host',
    name: 'container',
    development: {
      element: 'root_container',
      port: '8080',
      remoteFile,
    },
    production: {
      element: 'root_container',
      publicPath: 'container/latest',
      remoteFile,
    },
  },
  vitrine: {
    name: 'vitrine',
    type: 'remote',
    development: {
      element: 'root_vitrine',
      port: '8082',
      remoteFile,
    },
    production: {
      element: 'root_vitrine',
      publicPath: 'vitrine/latest',
      remoteFile,
    },
  },
  checkout: {
    name: 'checkout',
    type: 'remote',
    development: {
      element: 'root_checkout',
      port: '8083',
      remoteFile,
    },
    production: {
      element: 'root_checkout',
      publicPath: 'checkout/latest',
      remoteFile,
    },
  },
  customer_area: {
    name: 'customer_area',
    type: 'remote',
    development: {
      element: 'root_customer_area',
      port: '8087',
      remoteFile,
    },
    production: {
      element: 'root_customer_area',
      publicPath: 'customer-area/latest',
      remoteFile,
    },
  },
  multimarcas: {
    name: 'multimarcas',
    type: 'remote',
    development: {
      element: 'root_multimarcas',
      port: '8088',
      remoteFile,
    },
    production: {
      element: 'root_multimarcas',
      publicPath: 'multimarcas/latest',
      remoteFile,
    },
  },
}

module.exports = config
